import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/siteInfo';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.fullName,
  url: siteInfo.url,
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1 18层',
    addressLocality: '北京',
    addressRegion: '北京',
    addressCountry: 'CN',
  },
  foundingDate: siteInfo.foundingYear,
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.fullName,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: `${siteInfo.fullName} - ${siteInfo.tagline}`,
  description: siteInfo.description,
  url: siteInfo.url,
  isPartOf: {
    '@type': 'WebSite',
    name: siteInfo.fullName,
    url: siteInfo.url,
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <StatsSection />
        <CTASection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}